module.exports = "static/assets/2ec048ddd7a7e30b94f8d24c22892112.mp3";